import * as React from "react"
import { useTheme } from "../../ThemeContext";
const IconExpiringSoon = (props) => {
    const { theme } = useTheme();
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={62}
            height={62}
            fill="none"
            {...props}
        >
            <rect width={62} height={62} fill={theme === 'dark' ? "#37395B" : "#FEF0E7"} rx={31} />
            <path
                stroke={theme === 'dark' ? "#9aa1a7" : "#6C6C82"}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M31.916 47.5H20a3.667 3.667 0 0 1-3.667-3.667v-22A3.667 3.667 0 0 1 20 18.167h22a3.667 3.667 0 0 1 3.666 3.666V36.5m-7.333-22v7.333M23.666 14.5v7.333m-7.333 7.334h29.333m-7.333 14.666h11"
            />
        </svg>
    )
}
export default IconExpiringSoon
